import { personaAPI } from '../../services/api'

export default function PersonaPreview({ persona, onUseForJourney }) {
  if (!persona) return null

  const meta = persona.metadata || {}
  const demographics = meta.demographics || {}
  const archetype = meta.archetype
  const clinicalAdditions = meta.clinical_additions || {}

  return (
    <div className="card bg-base-100 shadow-xl">
      <div className="card-body">
        <h3 className="card-title text-lg">{persona.name}</h3>

        {/* Core config badges */}
        <div className="flex flex-wrap gap-2 my-2">
          <span className="badge badge-primary">{persona.sleep_disorder_type}</span>
          <span className="badge badge-secondary">{persona.primary_cause}</span>
          <span className="badge badge-accent">{persona.treatment_approach}</span>
        </div>

        {/* Demographic badges */}
        {(demographics.age_range || demographics.gender || demographics.occupation || archetype) && (
          <div className="flex flex-wrap gap-2">
            {demographics.age_range && <span className="badge badge-outline badge-sm">{demographics.age_range}</span>}
            {demographics.gender && <span className="badge badge-outline badge-sm">{demographics.gender}</span>}
            {demographics.occupation && <span className="badge badge-outline badge-sm">{demographics.occupation}</span>}
            {archetype && <span className="badge badge-info badge-sm">{archetype}</span>}
          </div>
        )}

        {/* Comorbidity chips */}
        {clinicalAdditions.comorbid_conditions?.length > 0 && (
          <div className="mt-2">
            <span className="text-xs text-base-content/50 mr-2">Comorbidities:</span>
            <div className="flex flex-wrap gap-1 mt-1">
              {clinicalAdditions.comorbid_conditions.map((c) => (
                <span key={c} className="badge badge-warning badge-xs">{c}</span>
              ))}
            </div>
          </div>
        )}

        {/* Profile */}
        <div className="mt-4 bg-base-200 rounded-lg p-4 max-h-96 overflow-y-auto">
          <pre className="whitespace-pre-wrap text-sm font-sans leading-relaxed">
            {persona.detailed_profile}
          </pre>
        </div>

        {/* Actions */}
        <div className="card-actions justify-end mt-4 gap-2">
          <button
            className="btn btn-outline btn-sm"
            onClick={() => personaAPI.exportJson(persona.id)}
          >
            Export JSON
          </button>
          {onUseForJourney && (
            <button
              className="btn btn-primary btn-sm"
              onClick={onUseForJourney}
            >
              Use for Journey →
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
